import React, { useState, useMemo, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import DataTable from '../components/DataTable';
import {
  fetchUsers,
  fetchAddresses,
  fetchAlerts,
  fetchArticles,
  fetchDailyKeywordFacebook,
  fetchDailyKeywordInstagram,
  fetchDailyKeywordThread,
  fetchDailyKeywordTikTok,
  fetchDailyKeywordTruth,
  fetchTruthTag,
  fetchTikTokChallenge,
  fetchInstagramPost,
  fetchDailyKeywordTweet,
  fetchXUser,
  fetchCompanies,
  fetchCompanyAddresses,
  fetchConfigurations,
  fetchKeywords,
  fetchPermissions,
  fetchRolePermission,
  fetchRoles,
  fetchUserAddress,
  fetchUserAlert,
  fetchUserRole,
} from '../api/apiClient';
import './../styles/dashboard.css';

const Dashboard = () => {
  const [activeEndpoint, setActiveEndpoint] = useState('users');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const endpoints = useMemo(() => [
    { id: 'users', name: 'Users', fetchFn: fetchUsers },
    { id: 'addresses', name: 'Addresses', fetchFn: fetchAddresses },
    { id: 'alerts', name: 'Alerts', fetchFn: fetchAlerts },
    { id: 'articles', name: 'Articles', fetchFn: fetchArticles },
    { id: 'daily_keyword_facebook', name: 'Facebook Keywords', fetchFn: fetchDailyKeywordFacebook },
    { id: 'daily_keyword_instagram', name: 'Instagram Keywords', fetchFn: fetchDailyKeywordInstagram },
    { id: 'daily_keyword_threads', name: 'Threads Keywords', fetchFn: fetchDailyKeywordThread },
    { id: 'daily_keyword_tiktoks', name: 'TikTok Keywords', fetchFn: fetchDailyKeywordTikTok },
    { id: 'daily_keyword_truths', name: 'Truth Keywords', fetchFn: fetchDailyKeywordTruth },
    { id: 'truth_tags', name: 'Truth Tags', fetchFn: fetchTruthTag },
    { id: 'instagram_posts', name: 'Instagram Posts', fetchFn: fetchInstagramPost },
    { id: 'daily_keyword_tweets', name: 'Tweet Keywords', fetchFn: fetchDailyKeywordTweet },
    { id: 'x_users', name: 'X Users', fetchFn: fetchXUser },
    { id: 'tiktok_challenges', name: 'TikTok Challenges', fetchFn: fetchTikTokChallenge },
    { id: 'companies', name: 'Companies', fetchFn: fetchCompanies },
    { id: 'company_addresses', name: 'Company Addresses', fetchFn: fetchCompanyAddresses },
    { id: 'configurations', name: 'Configurations', fetchFn: fetchConfigurations },
    { id: 'keywords', name: 'Keywords', fetchFn: fetchKeywords },
    { id: 'permissions', name: 'Permissions', fetchFn: fetchPermissions },
    { id: 'role_permissions', name: 'Role Permissions', fetchFn: fetchRolePermission },
    { id: 'roles', name: 'Roles', fetchFn: fetchRoles },
    { id: 'user_addresses', name: 'User Addresses', fetchFn: fetchUserAddress },
    { id: 'user_alert', name: 'User Alerts', fetchFn: fetchUserAlert },
    { id: 'user_roles', name: 'User Roles', fetchFn: fetchUserRole },
  ], []);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const endpoint = endpoints.find((e) => e.id === activeEndpoint);
        if (endpoint) {
          const response = await endpoint.fetchFn();
          setData(response.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [activeEndpoint, endpoints]);

  return (
    <div className="dashboard">
      <div className="dashboard-content">
        <Sidebar
          endpoints={endpoints}
          activeEndpoint={activeEndpoint}
          onSelect={setActiveEndpoint}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />
        <div className="dashboard-main">
          <h2>{endpoints.find((e) => e.id === activeEndpoint)?.name}</h2>
          {loading ? (
            <div className="loading-indicator">Loading data...</div>
          ) : (
            <DataTable data={data} endpoint={activeEndpoint} />
          )}
        </div>
      </div>

      {/* Mobile FAB to toggle sidebar */}
      <button
        className="sidebar-mobile-toggle"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Toggle sidebar"
      >
        {mobileOpen ? '✕' : '☰'}
      </button>
    </div>
  );
};

export default Dashboard;
